<script>
export default {
  name: 'ModalCutPreview',

  props: {
    cut: { type: Object, default: null },
  },

  data() {
    return { showModal: false };
  },

  methods: {
    open()  { this.showModal = true; },
    close() { this.showModal = false; },

    onModalHidden() {
      // Pause both videos when the modal closes
      ['videoCrop', 'videoFull'].forEach(ref => {
        const el = this.$refs[ref];
        if (el) el.pause();
      });
    },
  },
};
</script>

<template>
  <b-modal
    v-model="showModal"
    size="xl"
    :title="cut ? (cut.label || 'Cut Preview') : 'Cut Preview'"
    title-class="font-18"
    hide-footer
    @hidden="onModalHidden"
  >
    <div v-if="cut" class="cp-grid">

      <!-- Vertical / Crop -->
      <div v-if="cut.url_crop" class="cp-col cp-col--vertical">
        <div class="cp-label">
          <i class="mdi mdi-phone-rotate-portrait"></i> Vertical (Crop)
        </div>
        <video
          ref="videoCrop"
          class="cp-video cp-video--crop"
          :src="cut.url_crop"
          controls
          preload="metadata"
        ></video>
      </div>

      <!-- Horizontal / Full -->
      <div v-if="cut.url_full" class="cp-col cp-col--horizontal">
        <div class="cp-label">
          <i class="mdi mdi-phone-rotate-landscape"></i> Horizontal (Full)
        </div>
        <video
          ref="videoFull"
          class="cp-video cp-video--full"
          :src="cut.url_full"
          controls
          preload="metadata"
        ></video>
      </div>

    </div>
  </b-modal>
</template>

<style scoped>
.cp-grid {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.cp-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cp-col--vertical {
  flex: 0 0 auto;
}

.cp-col--horizontal {
  flex: 1;
  min-width: 0;
}

.cp-label {
  font-size: 12px;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 5px;
}

.cp-video {
  display: block;
  border-radius: 6px;
  background: #000;
}

.cp-video--crop {
  width: 220px;
  height: 390px;
  object-fit: contain;
}

.cp-video--full {
  width: 100%;
  max-height: 390px;
  object-fit: contain;
}
</style>
